import React from "react";

export default function Ex2_Data() {
  return (
    <div>
      <h1>Ex2_Data</h1>
      <p>This is the Ex2_Data component.</p>
    </div>
  );
}
